import { ICON_NAMES } from '../../../../../../../config/config';
import { ParticipantRole } from '../../../../../../../config/types';

export const PARTICIPANT_CARD_ICON_BY_ROLE = {
  [ParticipantRole.BORROWER]: ICON_NAMES.BORROWER,
  [ParticipantRole.CO_BORROWER]: ICON_NAMES.CO_BORROWER,
  [ParticipantRole.AGENT]: ICON_NAMES.AGENT,
  [ParticipantRole.CHANNEL]: ICON_NAMES.CHANNEL,
  [ParticipantRole.MERCHANT]: ICON_NAMES.MERCHANT,
};
